<nav class="navbar sticky-top navbar-expand container-header">
  <div class="container-fluid">
    <div
      class="collapse navbar-collapse row align-items-center justify-content-end"
    >
      <div class="col-auto">
        @if (userData$ | async; as userData) {
        <auth-user-menu
          [actions]="authUserMenu"
          [userName]="userData.user.username"
          userImage="assets/account-outline.svg"
          (action)="onActionDispached($event)"
        ></auth-user-menu>
        }
      </div>
      <div class="col-auto align-items-center logoutBtn" (click)="logout()">
        <div class="row g-1 p-0">
          <div class="col">
            <mat-icon
              class="action-elem"
              svgIcon="exit-app"
              aria-label="Side nav toggle icon"
            ></mat-icon>
          </div>
          <div class="col">
            <div class="d-inline action-elem">Salir</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
